import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import PropTypes from "prop-types";
import UitInVlaanderenForm from "./UitInVlaanderenForm";
import Section from "../../common/Section";
import UitInVlaanderenPageHelper from "./UitInVlaanderenPageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import { throwException } from "../../../actions/exceptionActions";

class UitInVlaanderenPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            content: [],
            fileName: "",
            tochtTypes: [],
            tochtTypeId: ""
        };

        this.pageHelper = new UitInVlaanderenPageHelper(this, null);
    }

    componentDidMount = () => {
        super.componentDidMount(); // better way to handle unsaved changes
        this.pageHelper.init();
    };

    componentWillUnmount() {

    }

    componentDidUpdate = () => {
        super.componentDidUpdate();
    };

    handleOnDropBestand = (component, files) => this.pageHelper.dropBestand(files);
    handleOnTochtTypeChange = (event) => this.setState({ tochtTypeId: event.target.value });
    handleOnSave = () => this.pageHelper.save();

    render() {
        const props = this.props;
        const state = this.state;
        const color = types.COLOR_PINK;

        return (
            <Section color={color}>
                <UitInVlaanderenForm
                    onSave={this.handleOnSave}
                    disabled={props.disabled}
                    onDropFiles={this.handleOnDropBestand}
                    onTochtTypeChange={this.handleOnTochtTypeChange}
                    fotoFileTypes={props.fotoFileTypes}
                    color={color}
                    fileName={state.fileName}
                    tochtTypes={state.tochtTypes}
                    tochtTypeId={state.tochtTypeId}
                />
            </Section>);
    }
}

UitInVlaanderenPage.propTypes = {
    fotoFileTypes: PropTypes.object,
    disabled: PropTypes.bool
};

function mapStateToProps(state) {
    const fotoFileTypes = state.settings.fileTypes[types.FileComponentNames.UIVFOTO];
    const disabled = state.settings.disabled;

    return {
        fotoFileTypes: fotoFileTypes,
        disabled: disabled,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UitInVlaanderenPage);
